import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Typography, useMediaQuery } from "@material-ui/core";
import { FormattedDate, FormattedNumber, useIntl } from "react-intl";
import { messages } from "../../messages";
import { clsx } from "clsx";
function formatNumber(value) {
    return (_jsx(FormattedNumber, { value: value, minimumFractionDigits: 2, maximumFractionDigits: 2, children: (formatted) => formatted.endsWith(",00") ? formatted.replace(",00", ",-") : formatted }));
}
const BuyoutPriceTable = ({ buyoutPrices, selectedCell, setSelectedCell, classes, application }) => {
    const hasDualPrices = buyoutPrices?.some(p => (p.BuyoutAmountExisting ?? 0) > 0 && (p.BuyoutAmountNew ?? 0) > 0);
    const intl = useIntl();
    // Helper to determine if a row should be disabled
    const isRowDisabled = (rowIdx) => {
        const termLength = application?.CurrentTermLength ?? 1;
        if (termLength === 1) {
            return rowIdx > 2;
        }
        else {
            return rowIdx > 0;
        }
    };
    const desktopGridTwoColumns = `
			". title ."
			". priceExistingDesc priceNewDesc "
			${buyoutPrices
        ?.map((_, i) => `"date${i} priceExisting${i} priceNew${i}"`)
        .join(" ") ?? ""}
		`;
    const mobileGridTwoColumns = `
			"title ."
			"priceExistingDesc priceNewDesc"
			${buyoutPrices
        ?.map((_, i) => `"date${i} ." "priceExisting${i} priceNew${i}"`)
        .join(" ") ?? ""}
		`;
    const gridOneColumn = `
			". title"
			${buyoutPrices?.map((_, i) => `"date${i} priceExisting${i}"`).join(" ") ?? ""}
		`;
    const isMobile = useMediaQuery("(max-width:600px)");
    const grid = {
        display: "grid",
        alignItems: "center",
        columnGap: 16,
        rowGap: 16,
        gridTemplateColumns: hasDualPrices
            ? isMobile
                ? "1fr 1fr" // mobile two columns
                : "1fr 2fr 2fr" // desktop two columns
            : isMobile
                ? "1fr 1fr" // mobile one column
                : "1fr 2fr",
        gridTemplateAreas: hasDualPrices
            ? isMobile
                ? mobileGridTwoColumns
                : desktopGridTwoColumns
            : gridOneColumn,
        width: isMobile ? "100%" : hasDualPrices ? "90%" : "60%"
    };
    return (_jsxs(Box, { style: grid, children: [_jsx(Typography, { className: classes.priceTypeTitle, style: { gridArea: "title" }, children: intl.formatMessage(messages.vendorPriceTitle) }), hasDualPrices && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "body2", style: { gridArea: "priceNewDesc" }, children: intl.formatMessage(messages.vendorPriceNew) }), _jsx(Typography, { variant: "body2", style: { gridArea: "priceExistingDesc" }, children: intl.formatMessage(messages.vendorPriceExisting) })] })), buyoutPrices?.map((price, rowIdx) => {
                const disabled = isRowDisabled(rowIdx);
                return (_jsxs(React.Fragment, { children: [_jsx(Typography, { style: { gridArea: `date${rowIdx}` }, children: price.RemainingTerms === 0 ||
                                price.RemainingTerms === undefined ? (intl.formatMessage(messages.lastTerm)) : (_jsx(FormattedDate, { value: price.BuyoutDate, year: "numeric", month: "long", day: "numeric" })) }), hasDualPrices && (_jsx(Box, { className: clsx(classes.priceBox, {
                                [classes.priceBoxDisabled]: disabled,
                                [classes.priceBoxSelected]: selectedCell?.col === 0 && selectedCell?.row === rowIdx
                            }), style: { gridArea: `priceNew${rowIdx}` }, onClick: disabled
                                ? undefined
                                : () => setSelectedCell({ col: 0, row: rowIdx }), role: "button", tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, children: formatNumber(price.BuyoutAmountNew) })), _jsx(Box, { className: clsx(classes.priceBox, {
                                [classes.priceBoxDisabled]: disabled,
                                [classes.priceBoxSelected]: selectedCell?.col === 1 && selectedCell?.row === rowIdx
                            }), style: { gridArea: `priceExisting${rowIdx}` }, onClick: disabled
                                ? undefined
                                : () => setSelectedCell({ col: 1, row: rowIdx }), role: "button", tabIndex: disabled ? -1 : 0, "aria-disabled": disabled, children: formatNumber(price.BuyoutAmountExisting) })] }, rowIdx));
            })] }));
};
export default BuyoutPriceTable;
//# sourceMappingURL=BuyoutPriceTable.js.map